import React from 'react';
import PageBanner from '../../../layout/PageBanner';
import { Link } from 'react-router-dom';

const QuienesSomosDetalle = (props) => (
  <div>
    <div>
    <PageBanner title="Quiénes Somos" img="banner-quienes-somos.jpg">
      <Link to="/">Home</Link>
      <Link to="/quienes-somos">Quienes Somos</Link>
      
      <a>{props.location[0].nombre}</a>
    </PageBanner>

        {(props.location.length) &&
          <section className="about-ds">
          		<div className="container">
          			<div className="row">
          	      <div className="col-md-7 col-sm-6 about-ds-content">
          					<div className="section-header03">
          						<h2>
                        <span>{props.location[0].nombre.substring(0, props.location[0].nombre.indexOf(' '))} </span>
                        {props.location[0].nombre.substring(props.location[0].nombre.indexOf(' ')+1)}
                      </h2>
          					</div>
                    <p className="fade-in" dangerouslySetInnerHTML={{ __html: props.location[0].cv }}>
                    </p>
                    <Link to="/quienes-somos"><span className="rm-btn el-btn-regular flacso-verde">Volver</span></Link>
                  </div>
    	            <div className="col-md-5 col-sm-6 about-ds-image fade-in">
    	            	<img src={props.location[0].imagen} alt={props.location[0].nombre} className="img-responsive"/>
    	            </div>
          			</div>
          		</div>
        	</section>
        }
        {!props.location &&
            <div className="contenedor-descripcion">
              <h1>Colaborador no disponible</h1>
            </div>
        }

    </div>
  </div>
);

export default QuienesSomosDetalle;
